// @ts-nocheck
/* eslint-disable */
import MyMapsPopup from "~/es6/mymaps.popup";
import { _ } from "~/i18n";

(function() {
	/**
	 * Trida pro overlay v iframu
	 */
	class FrameOverlay {
		/**
		 * konstruktor
		 */
		constructor() {
			document.body.classList.add("frameO");

			this._dimm = Mapy.Util.node("div", { className: "frame-overlay" });
			this._popup = new MyMapsPopup({
				cb: data => {
					if (data.name == "close") {
						cont.remove();
					}
				},
				name: "",
				userClose: false
			});
			let cont = this._popup.getContainer();

			let h2 = Mapy.Util.node("h2", {}, _("frame.title"));
			let a1 = Mapy.Util.node("a", { href: "https://napoveda.seznam.cz/forum/threads/131163/1", title: "", target: "_blank" }, _("frame.href1"));
			let a2 = Mapy.Util.node("a", { href: window.location, target: "_blank" }, _("frame.href2"));
			let btn = Mapy.Util.node("button", { className: "button" }, "OK");
			btn.setAttribute("button", "button");

			btn.addEventListener("click", e => {
				e.preventDefault();

				this._popup.close();
			});

			cont.appendChild(h2);
			cont.appendChild(a1);
			cont.appendChild(a2);
			cont.appendChild(btn);

			this._dimm.appendChild(cont);
			document.body.appendChild(this._dimm);
		}
	}

	Mapy.FrameOverlay = FrameOverlay;
}());


